export type IndexedBlobLike = Blob | ArrayBuffer

/**
 * Safari/WebKit can fail to persist raw Blobs in IndexedDB. Persist bytes +
 * mime type when possible, and keep a Blob fallback for best-effort recovery.
 */
export async function toStorableBlobPayload(
  blob: Blob,
): Promise<{ value: IndexedBlobLike; type: string }> {
  try {
    return {
      value: await blob.arrayBuffer(),
      type: blob.type || '',
    }
  } catch {
    return {
      value: blob,
      type: blob.type || '',
    }
  }
}

export function toReadableBlob(blob: IndexedBlobLike | undefined, blobType?: string): Blob | null {
  if (!blob) return null
  if (blob instanceof Blob) return blob
  if (blob instanceof ArrayBuffer) return new Blob([blob], { type: blobType || '' })
  return null
}
